<template>
  <div class="gl-popover-hint">
    <v-popover
      auto-hide
      :boundaries-element="boundariesElement"
      :offset="offset"
      :open.sync="innerValue"
      placement="top"
    >
      <slot name="action-element" />

      <template slot="popover">
        <div class="gl-popover-hint-content-wrapper">
          <div class="flex space-between gap-3 fs-14 bold-700 mb-2">
            <div> {{ headText }} </div>
            <div>
              <gl-icon
                v-if="closable"
                class="pointer"
                :height="12"
                name="close"
                :width="12"
                @click="innerValue = false"
              />
            </div>
          </div>
          <div class="gl-popover-hint-content-body-wrapper">
            <slot name="content-body" />
          </div>
        </div>
      </template>
    </v-popover>
  </div>
</template>

<script>
// Components
import GlIcon from '@/components/gl-icon'

export default {
  name: 'GlPopoverHint',
  components: {
    GlIcon,
  },
  props: {
    headText: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
      default: false,
    },
    closable: {
      type: Boolean,
      default: false,
    },
    offset: {
      type: [Number, String],
      default: '16px',
    },
    boundariesElement: {
      type: HTMLDivElement,
      default: false,
    },
  },
  computed: {
    innerValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
}
</script>

<style>
.gl-popover-hint {
  display: flex;
  justify-content: center;
}
</style>
